module.exports = __webpack_public_path__ + "7aeaafbcaadaeac42bfb50f435b0426e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio6/Lungenflugel.jpg
// module id = 908
// module chunks = 0